import ResourceCategoryLibrary from "../components/ResourceCategoryLibrary/ResourceCategoryLibrary";
import { WellKnownLearningMaterialCategories } from "UIPalette/LearningMaterials/wellKnownLearningMaterials";
import { useTranslation } from "react-i18next";
import { ResourceViewer } from "../components/ResourceViewer/ResourceViewer";
import { useNavBarContext } from "core/state/NavBarContext/NavBarContext";

export const ViewAudioAndVideo = () => {
  const { t } = useTranslation();
  useNavBarContext({ title: t("pageTitleOverride.audioAndVideo") });
  return <ResourceViewer pageTitle="pageTitle.resources.audioAndVideoArticles.article" />;
};

export const AudioAndVideo = () => {
  const { t } = useTranslation();
  useNavBarContext({ title: t("pageTitleOverride.audioAndVideo") });

  return (
    <ResourceCategoryLibrary
      category={WellKnownLearningMaterialCategories.audioAndVideo}
      pageTitle={t("pageTitle.resources.audioAndVideoArticles.home")}
    />
  );
};
